import mspLogo from "@/assets/clients/msp.png";
import kashviLogo from "@/assets/clients/kashvi.jpeg";
import concastLogo from "@/assets/clients/concast.png";
import jaiBalajiLogo from "@/assets/clients/jai-balaji.png";
import captainLogo from "@/assets/clients/captain.png";
import gaganLogo from "@/assets/clients/gagan.png";
import elegantLogo from "@/assets/clients/elegant.jpeg";
import sharpFerroLogo from "@/assets/clients/sharp-ferro.jpeg";
import shyamSteelLogo from "@/assets/clients/shyam-steel.png";
import rashmiLogo from "@/assets/clients/rashmi.png";
import sundaramLogo from "@/assets/clients/sundaram.jpeg";
import balmukundLogo from "@/assets/clients/balmukund.jpeg";
import neoMetaliksLogo from "@/assets/clients/neo-metaliks.png";
import beekayLogo from "@/assets/clients/beekay.png";
import adhunikLogo from "@/assets/clients/adhunik.jpeg";
import maithanLogo from "@/assets/clients/maithan.png";
import superShaktiLogo from "@/assets/clients/super-shakti.png";
import srmbLogo from "@/assets/clients/srmb.png";
import crmIspatLogo from "@/assets/clients/crm-ispat.png";
import renukaLogo from "@/assets/clients/renuka.png";

const CLIENTS: { name: string; logo: string }[] = [
  { name: "SRMB TMT", logo: srmbLogo },
  { name: "CRM Ispat", logo: crmIspatLogo },
  { name: "MSP", logo: mspLogo },
  { name: "Kashvi", logo: kashviLogo },
  { name: "Concast Maxx", logo: concastLogo },
  { name: "Jai Balaji Group", logo: jaiBalajiLogo },
  { name: "Captain TMT", logo: captainLogo },
  { name: "Gagan TMT", logo: gaganLogo },
  { name: "Elegant Steel", logo: elegantLogo },
  { name: "Sharp Ferro Alloys", logo: sharpFerroLogo },
  { name: "Shyam Steel", logo: shyamSteelLogo },
  { name: "Rashmi Group", logo: rashmiLogo },
  { name: "Sundaram Steels", logo: sundaramLogo },
  { name: "Balmukund Sponge & Iron", logo: balmukundLogo },
  { name: "Neo Metaliks", logo: neoMetaliksLogo },
  { name: "Beekay Steel", logo: beekayLogo },
  { name: "Adhunik Group", logo: adhunikLogo },
  { name: "Maithan Steel", logo: maithanLogo },
  { name: "Super Shakti", logo: superShaktiLogo },
  { name: "Renuka Steel Industries", logo: renukaLogo },
];

export const TrustedClients = () => {
  const loop = [...CLIENTS, ...CLIENTS];

  return (
    <section className="container py-12 md:py-16">
      <div className="mx-auto max-w-2xl text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent/15 px-3 py-1 text-xs font-bold uppercase tracking-widest text-accent">
          Trusted partners
        </span>
        <h2 className="mt-3 text-2xl font-bold md:text-3xl">
          Foundries & rolling mills we've supplied
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          A snapshot of factories and steel producers who have sourced scrap
          through LohaLink — directly or via our partner yards.
        </p>
      </div>

      <div
        className="group relative mt-8 overflow-hidden"
        aria-label="Partner factories and clients"
        style={{
          maskImage:
            "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
          WebkitMaskImage:
            "linear-gradient(to right, transparent, black 8%, black 92%, transparent)",
        }}
      >
        <ul className="flex w-max animate-marquee items-center gap-6 group-hover:[animation-play-state:paused]">
          {loop.map((client, i) => (
            <li
              key={`${client.name}-${i}`}
              className="flex h-24 w-44 shrink-0 items-center justify-center rounded-xl border border-border bg-card px-4 py-3 shadow-sm"
            >
              <img
                src={client.logo}
                alt={`${client.name} logo`}
                loading="lazy"
                className="max-h-16 max-w-full object-contain"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
